module.exports = __webpack_public_path__ + "img/6.a4766f49.png";